/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thiswillmakethelistingvisibletoallusers8Inputs */

const en_thiswillmakethelistingvisibletoallusers8 = /** @type {(inputs: Thiswillmakethelistingvisibletoallusers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will make the listing visible to all users.`)
};

const de_thiswillmakethelistingvisibletoallusers8 = /** @type {(inputs: Thiswillmakethelistingvisibletoallusers8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dann sehen alle den Ort.`)
};

/**
* | output |
* | --- |
* | "This will make the listing visible to all users." |
*
* @param {Thiswillmakethelistingvisibletoallusers8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const thiswillmakethelistingvisibletoallusers8 = /** @type {((inputs?: Thiswillmakethelistingvisibletoallusers8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thiswillmakethelistingvisibletoallusers8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_thiswillmakethelistingvisibletoallusers8(inputs)
	return de_thiswillmakethelistingvisibletoallusers8(inputs)
});
export { thiswillmakethelistingvisibletoallusers8 as "thisWillMakeTheListingVisibleToAllUsers" }